module.exports = __webpack_public_path__ + "static/media/banner.7cba5983.jpg";